import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useThemes } from "../Theme/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteJournalEntries = ({
  open,
  setOpen,
  entryInd,
  entryRows,
  entryRowsOne,
  setEntryRowsOne,
  setEntryRows,
  setSnakbarTex,
  rowsNo,
  setRowsOneInd,
  setRowsInd,
  displayRowOneBalance,
  displayRowTwoBalance,
  transArr,
  setTransArr
}) => {
  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const { theme } = useThemes()
  const deleteItem = () => {

    setLoading(true);
    let rowOneAccID = { id: "", ind: "" };
    let rowTwoAccID = { id: "", ind: "" };
    if (rowsNo === 2) {
      entryRows.map((ele, ind) => {
        if (ind === entryInd) {
          rowTwoAccID = { id: ele?.ledgerAccount?.value, ind: ind }
        }
      });

      const transactionArr = transArr.filter(item => item?.accountid != rowTwoAccID?.id);
      
      setTransArr(transactionArr)
      const arr = entryRows.filter((item, ind) => ind !== entryInd);

      setEntryRows(arr);
      displayRowTwoBalance(rowTwoAccID?.id, rowTwoAccID?.ind, [...arr, ...entryRowsOne], transactionArr);

      if (arr.length === 0) {
        setEntryRows([]);
        setRowsInd("");
      }
    } else if (entryRowsOne !== undefined) {
      entryRowsOne.map((ele, ind) => {
        if (ind === entryInd) {
          rowOneAccID = { id: ele?.ledgerAccount?.value, ind: ind }
        }
      });
      const transactionArr = transArr.filter(item => item?.accountid != rowOneAccID?.id);
      setTransArr(transactionArr)
      const arr = entryRowsOne.filter((item, ind) => ind !== entryInd);
      setEntryRowsOne(arr);
      displayRowOneBalance(rowOneAccID?.id, rowOneAccID?.ind, [...arr, ...entryRows]);

      if (arr.length === 0) {
        setEntryRowsOne([]);
        setRowsOneInd("");
      }
    }

    setOpen(false);
    setLoading(false);
    setSnakbarTex("Entry Deleted");
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "#FFF1E6" : "rgb(60 60 60)", fontWeight: "bold" }}>
            Do you want to delete this item?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            id="Action"
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            id="Action"
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteJournalEntries;
